/* eslint-disable */
/* oxlint-disable */
/* prettier-ignore-file */
// @ts-nocheck
// This file is auto-generated. Do not edit manually.
// Run 'pnpm codegen' to regenerate this file.

import { Uuid, UuidJsonValue, Uuid_fromJsonValue, Uuid_toJsonValue, Symbol, SymbolJsonValue, Symbol_fromJsonValue, Symbol_toJsonValue, AccountOrderKey, AccountOrderKeyJsonValue, AccountOrderKey_fromJsonValue, AccountOrderKey_toJsonValue } from './prex.v2.r230522.id';
import { PswapOrderSide, PswapOrderSideJsonValue, PswapOrderSide_fromJsonValue, PswapOrderSide_toJsonValue, OrderType, OrderTypeJsonValue, OrderType_fromJsonValue, OrderType_toJsonValue, PriceMatchStrategy, PriceMatchStrategyJsonValue, PriceMatchStrategy_fromJsonValue, PriceMatchStrategy_toJsonValue, OrderAction, OrderActionJsonValue, OrderAction_fromJsonValue, OrderAction_toJsonValue, ConditionalOrderType, ConditionalOrderTypeJsonValue, ConditionalOrderType_fromJsonValue, ConditionalOrderType_toJsonValue, OrderTriggerDirection, OrderTriggerDirectionJsonValue, OrderTriggerDirection_fromJsonValue, OrderTriggerDirection_toJsonValue, OrderTriggerPriceType, OrderTriggerPriceTypeJsonValue, OrderTriggerPriceType_fromJsonValue, OrderTriggerPriceType_toJsonValue, TpslOrderType, TpslOrderTypeJsonValue, TpslOrderType_fromJsonValue, TpslOrderType_toJsonValue } from './prex.v2.r230522.order';
import { PrexDecimal, PrexDecimalJsonValue, PrexDecimal_fromJsonValue, PrexDecimal_toJsonValue, PrexTimestamp, PrexTimestampJsonValue, PrexTimestamp_fromJsonValue, PrexTimestamp_toJsonValue } from './prex.shared.primitives';

export interface PswapOrder {
  accountId: number;
  orderId: Uuid;
  slot: number;
  symbol: Symbol;
  initLeverage?: number;
  side: PswapOrderSide;
  orderType: OrderType;
  price?: PrexDecimal;
  priceMatchStrategy?: PriceMatchStrategy;
  qty?: PrexDecimal;
  leavesQty?: PrexDecimal;
  amount?: PrexDecimal;
  leavesAmount?: PrexDecimal;
  orderTime: PrexTimestamp;
  action: OrderAction;
  conditionalOrderType: ConditionalOrderType;
  triggerPrice?: PrexDecimal;
  triggerDirection?: OrderTriggerDirection;
  triggerPriceType?: OrderTriggerPriceType;
  triggerTimestamp?: PrexTimestamp;
  orderTpTriggerPrice?: PrexDecimal;
  orderTpTriggerPriceType?: OrderTriggerPriceType;
  orderSlTriggerPrice?: PrexDecimal;
  orderSlTriggerPriceType?: OrderTriggerPriceType;
  orderTpTriggerPriceRatio?: PrexDecimal;
  orderSlTriggerPriceRatio?: PrexDecimal;
  orderTpOrderQty?: PrexDecimal;
  orderSlOrderQty?: PrexDecimal;
  orderTpOrderType?: TpslOrderType;
  orderTpLimitPrice?: PrexDecimal;
  orderTpPriceMatchStrategy?: PriceMatchStrategy;
  orderSlOrderType?: TpslOrderType;
  orderSlLimitPrice?: PrexDecimal;
  orderSlPriceMatchStrategy?: PriceMatchStrategy;
  waitingTrigger: boolean;
  isReduceOnly: boolean;
  execInst: number;
  execInsts: ExecInst[];
  avgEntryPrice?: PrexDecimal;
}
export interface PswapOrderJsonValue {
  accountId: number;
  orderId: UuidJsonValue;
  slot: number;
  symbol: SymbolJsonValue;
  initLeverage?: number;
  side: PswapOrderSideJsonValue;
  orderType: OrderTypeJsonValue;
  price?: PrexDecimalJsonValue;
  priceMatchStrategy?: PriceMatchStrategyJsonValue;
  qty?: PrexDecimalJsonValue;
  leavesQty?: PrexDecimalJsonValue;
  amount?: PrexDecimalJsonValue;
  leavesAmount?: PrexDecimalJsonValue;
  orderTime: PrexTimestampJsonValue;
  action: OrderActionJsonValue;
  conditionalOrderType: ConditionalOrderTypeJsonValue;
  triggerPrice?: PrexDecimalJsonValue;
  triggerDirection?: OrderTriggerDirectionJsonValue;
  triggerPriceType?: OrderTriggerPriceTypeJsonValue;
  triggerTimestamp?: PrexTimestampJsonValue;
  orderTpTriggerPrice?: PrexDecimalJsonValue;
  orderTpTriggerPriceType?: OrderTriggerPriceTypeJsonValue;
  orderSlTriggerPrice?: PrexDecimalJsonValue;
  orderSlTriggerPriceType?: OrderTriggerPriceTypeJsonValue;
  orderTpTriggerPriceRatio?: PrexDecimalJsonValue;
  orderSlTriggerPriceRatio?: PrexDecimalJsonValue;
  orderTpOrderQty?: PrexDecimalJsonValue;
  orderSlOrderQty?: PrexDecimalJsonValue;
  orderTpOrderType?: TpslOrderTypeJsonValue;
  orderTpLimitPrice?: PrexDecimalJsonValue;
  orderTpPriceMatchStrategy?: PriceMatchStrategyJsonValue;
  orderSlOrderType?: TpslOrderTypeJsonValue;
  orderSlLimitPrice?: PrexDecimalJsonValue;
  orderSlPriceMatchStrategy?: PriceMatchStrategyJsonValue;
  waitingTrigger: boolean;
  isReduceOnly: boolean;
  execInst: number;
  execInsts: ExecInstJsonValue[];
  avgEntryPrice?: PrexDecimalJsonValue;
}
export function PswapOrder_fromJsonValue(json: PswapOrderJsonValue): PswapOrder {
  return {
    accountId: json['accountId'],
    orderId: Uuid_fromJsonValue(json['orderId']),
    slot: json['slot'],
    symbol: Symbol_fromJsonValue(json['symbol']),
    initLeverage: json['initLeverage'] != null ? json['initLeverage'] : undefined,
    side: PswapOrderSide_fromJsonValue(json['side']),
    orderType: OrderType_fromJsonValue(json['orderType']),
    price: json['price'] != null ? PrexDecimal_fromJsonValue(json['price']) : undefined,
    priceMatchStrategy: json['priceMatchStrategy'] != null ? PriceMatchStrategy_fromJsonValue(json['priceMatchStrategy']) : undefined,
    qty: json['qty'] != null ? PrexDecimal_fromJsonValue(json['qty']) : undefined,
    leavesQty: json['leavesQty'] != null ? PrexDecimal_fromJsonValue(json['leavesQty']) : undefined,
    amount: json['amount'] != null ? PrexDecimal_fromJsonValue(json['amount']) : undefined,
    leavesAmount: json['leavesAmount'] != null ? PrexDecimal_fromJsonValue(json['leavesAmount']) : undefined,
    orderTime: PrexTimestamp_fromJsonValue(json['orderTime']),
    action: OrderAction_fromJsonValue(json['action']),
    conditionalOrderType: ConditionalOrderType_fromJsonValue(json['conditionalOrderType']),
    triggerPrice: json['triggerPrice'] != null ? PrexDecimal_fromJsonValue(json['triggerPrice']) : undefined,
    triggerDirection: json['triggerDirection'] != null ? OrderTriggerDirection_fromJsonValue(json['triggerDirection']) : undefined,
    triggerPriceType: json['triggerPriceType'] != null ? OrderTriggerPriceType_fromJsonValue(json['triggerPriceType']) : undefined,
    triggerTimestamp: json['triggerTimestamp'] != null ? PrexTimestamp_fromJsonValue(json['triggerTimestamp']) : undefined,
    orderTpTriggerPrice: json['orderTpTriggerPrice'] != null ? PrexDecimal_fromJsonValue(json['orderTpTriggerPrice']) : undefined,
    orderTpTriggerPriceType: json['orderTpTriggerPriceType'] != null ? OrderTriggerPriceType_fromJsonValue(json['orderTpTriggerPriceType']) : undefined,
    orderSlTriggerPrice: json['orderSlTriggerPrice'] != null ? PrexDecimal_fromJsonValue(json['orderSlTriggerPrice']) : undefined,
    orderSlTriggerPriceType: json['orderSlTriggerPriceType'] != null ? OrderTriggerPriceType_fromJsonValue(json['orderSlTriggerPriceType']) : undefined,
    orderTpTriggerPriceRatio: json['orderTpTriggerPriceRatio'] != null ? PrexDecimal_fromJsonValue(json['orderTpTriggerPriceRatio']) : undefined,
    orderSlTriggerPriceRatio: json['orderSlTriggerPriceRatio'] != null ? PrexDecimal_fromJsonValue(json['orderSlTriggerPriceRatio']) : undefined,
    orderTpOrderQty: json['orderTpOrderQty'] != null ? PrexDecimal_fromJsonValue(json['orderTpOrderQty']) : undefined,
    orderSlOrderQty: json['orderSlOrderQty'] != null ? PrexDecimal_fromJsonValue(json['orderSlOrderQty']) : undefined,
    orderTpOrderType: json['orderTpOrderType'] != null ? TpslOrderType_fromJsonValue(json['orderTpOrderType']) : undefined,
    orderTpLimitPrice: json['orderTpLimitPrice'] != null ? PrexDecimal_fromJsonValue(json['orderTpLimitPrice']) : undefined,
    orderTpPriceMatchStrategy: json['orderTpPriceMatchStrategy'] != null ? PriceMatchStrategy_fromJsonValue(json['orderTpPriceMatchStrategy']) : undefined,
    orderSlOrderType: json['orderSlOrderType'] != null ? TpslOrderType_fromJsonValue(json['orderSlOrderType']) : undefined,
    orderSlLimitPrice: json['orderSlLimitPrice'] != null ? PrexDecimal_fromJsonValue(json['orderSlLimitPrice']) : undefined,
    orderSlPriceMatchStrategy: json['orderSlPriceMatchStrategy'] != null ? PriceMatchStrategy_fromJsonValue(json['orderSlPriceMatchStrategy']) : undefined,
    waitingTrigger: json['waitingTrigger'],
    isReduceOnly: json['isReduceOnly'],
    execInst: json['execInst'],
    execInsts: json['execInsts'].map((x: any) => ExecInst_fromJsonValue(x)),
    avgEntryPrice: json['avgEntryPrice'] != null ? PrexDecimal_fromJsonValue(json['avgEntryPrice']) : undefined,
  };
}
export function PswapOrder_toJsonValue(value: PswapOrder): PswapOrderJsonValue {
  return {
    'accountId': value.accountId,
    'orderId': Uuid_toJsonValue(value.orderId),
    'slot': value.slot,
    'symbol': Symbol_toJsonValue(value.symbol),
    'initLeverage': value.initLeverage != null ? value.initLeverage : undefined,
    'side': PswapOrderSide_toJsonValue(value.side),
    'orderType': OrderType_toJsonValue(value.orderType),
    'price': value.price != null ? PrexDecimal_toJsonValue(value.price) : undefined,
    'priceMatchStrategy': value.priceMatchStrategy != null ? PriceMatchStrategy_toJsonValue(value.priceMatchStrategy) : undefined,
    'qty': value.qty != null ? PrexDecimal_toJsonValue(value.qty) : undefined,
    'leavesQty': value.leavesQty != null ? PrexDecimal_toJsonValue(value.leavesQty) : undefined,
    'amount': value.amount != null ? PrexDecimal_toJsonValue(value.amount) : undefined,
    'leavesAmount': value.leavesAmount != null ? PrexDecimal_toJsonValue(value.leavesAmount) : undefined,
    'orderTime': PrexTimestamp_toJsonValue(value.orderTime),
    'action': OrderAction_toJsonValue(value.action),
    'conditionalOrderType': ConditionalOrderType_toJsonValue(value.conditionalOrderType),
    'triggerPrice': value.triggerPrice != null ? PrexDecimal_toJsonValue(value.triggerPrice) : undefined,
    'triggerDirection': value.triggerDirection != null ? OrderTriggerDirection_toJsonValue(value.triggerDirection) : undefined,
    'triggerPriceType': value.triggerPriceType != null ? OrderTriggerPriceType_toJsonValue(value.triggerPriceType) : undefined,
    'triggerTimestamp': value.triggerTimestamp != null ? PrexTimestamp_toJsonValue(value.triggerTimestamp) : undefined,
    'orderTpTriggerPrice': value.orderTpTriggerPrice != null ? PrexDecimal_toJsonValue(value.orderTpTriggerPrice) : undefined,
    'orderTpTriggerPriceType': value.orderTpTriggerPriceType != null ? OrderTriggerPriceType_toJsonValue(value.orderTpTriggerPriceType) : undefined,
    'orderSlTriggerPrice': value.orderSlTriggerPrice != null ? PrexDecimal_toJsonValue(value.orderSlTriggerPrice) : undefined,
    'orderSlTriggerPriceType': value.orderSlTriggerPriceType != null ? OrderTriggerPriceType_toJsonValue(value.orderSlTriggerPriceType) : undefined,
    'orderTpTriggerPriceRatio': value.orderTpTriggerPriceRatio != null ? PrexDecimal_toJsonValue(value.orderTpTriggerPriceRatio) : undefined,
    'orderSlTriggerPriceRatio': value.orderSlTriggerPriceRatio != null ? PrexDecimal_toJsonValue(value.orderSlTriggerPriceRatio) : undefined,
    'orderTpOrderQty': value.orderTpOrderQty != null ? PrexDecimal_toJsonValue(value.orderTpOrderQty) : undefined,
    'orderSlOrderQty': value.orderSlOrderQty != null ? PrexDecimal_toJsonValue(value.orderSlOrderQty) : undefined,
    'orderTpOrderType': value.orderTpOrderType != null ? TpslOrderType_toJsonValue(value.orderTpOrderType) : undefined,
    'orderTpLimitPrice': value.orderTpLimitPrice != null ? PrexDecimal_toJsonValue(value.orderTpLimitPrice) : undefined,
    'orderTpPriceMatchStrategy': value.orderTpPriceMatchStrategy != null ? PriceMatchStrategy_toJsonValue(value.orderTpPriceMatchStrategy) : undefined,
    'orderSlOrderType': value.orderSlOrderType != null ? TpslOrderType_toJsonValue(value.orderSlOrderType) : undefined,
    'orderSlLimitPrice': value.orderSlLimitPrice != null ? PrexDecimal_toJsonValue(value.orderSlLimitPrice) : undefined,
    'orderSlPriceMatchStrategy': value.orderSlPriceMatchStrategy != null ? PriceMatchStrategy_toJsonValue(value.orderSlPriceMatchStrategy) : undefined,
    'waitingTrigger': value.waitingTrigger,
    'isReduceOnly': value.isReduceOnly,
    'execInst': value.execInst,
    'execInsts': value.execInsts.map((x: any) => ExecInst_toJsonValue(x)),
    'avgEntryPrice': value.avgEntryPrice != null ? PrexDecimal_toJsonValue(value.avgEntryPrice) : undefined,
  };
}

export type ExecInst =
  | 'EXEC_INST_INVALID'
  | 'EXEC_INST_PARTICIPATE_DO_NOT_INITIATE'
  | 'EXEC_INST_REDUCE_ONLY'
  | 'EXEC_INST_CLOSE'
  | 'EXEC_INST_OPEN'
  | 'EXEC_INST_FLIP'
  | 'EXEC_INST_INCREASE'
  | 'EXEC_INST_IGNORE_EACH_OTHER';
export type ExecInstJsonValue = ExecInst;
export const ExecInst_values: ExecInst[] = ['EXEC_INST_INVALID', 'EXEC_INST_PARTICIPATE_DO_NOT_INITIATE', 'EXEC_INST_REDUCE_ONLY', 'EXEC_INST_CLOSE', 'EXEC_INST_OPEN', 'EXEC_INST_FLIP', 'EXEC_INST_INCREASE', 'EXEC_INST_IGNORE_EACH_OTHER'];
export function ExecInst_fromJsonValue(json: ExecInstJsonValue): ExecInst {
  return json as ExecInst;
}
export function ExecInst_toJsonValue(value: ExecInst): ExecInstJsonValue {
  return value;
}

export interface PswapOrderDelta {
  accountId?: number;
  slot?: number;
  symbol?: Symbol;
  initLeverage?: number;
  side?: PswapOrderSide;
  price?: PrexDecimal;
  priceMatchStrategy?: PriceMatchStrategy;
  qty?: PrexDecimal;
  amount?: PrexDecimal;
  leavesAmount?: PrexDecimal;
  conditionalOrderType?: ConditionalOrderType;
  triggerPrice?: PrexDecimal;
  triggerDirection?: OrderTriggerDirection;
  triggerPriceType?: OrderTriggerPriceType;
  triggerTimestamp?: PrexTimestamp;
  orderTpTriggerPrice?: PrexDecimal;
  orderTpTriggerPriceType?: OrderTriggerPriceType;
  orderSlTriggerPrice?: PrexDecimal;
  orderSlTriggerPriceType?: OrderTriggerPriceType;
  orderTpTriggerPriceRatio?: PrexDecimal;
  orderSlTriggerPriceRatio?: PrexDecimal;
  orderTpOrderQty?: PrexDecimal;
  orderSlOrderQty?: PrexDecimal;
  orderTpOrderType?: TpslOrderType;
  orderTpLimitPrice?: PrexDecimal;
  orderTpPriceMatchStrategy?: PriceMatchStrategy;
  orderSlOrderType?: TpslOrderType;
  orderSlLimitPrice?: PrexDecimal;
  orderSlPriceMatchStrategy?: PriceMatchStrategy;
  waitingTrigger?: boolean;
  isReduceOnly?: boolean;
}
export interface PswapOrderDeltaJsonValue {
  accountId?: number;
  slot?: number;
  symbol?: SymbolJsonValue;
  initLeverage?: number;
  side?: PswapOrderSideJsonValue;
  price?: PrexDecimalJsonValue;
  priceMatchStrategy?: PriceMatchStrategyJsonValue;
  qty?: PrexDecimalJsonValue;
  amount?: PrexDecimalJsonValue;
  leavesAmount?: PrexDecimalJsonValue;
  conditionalOrderType?: ConditionalOrderTypeJsonValue;
  triggerPrice?: PrexDecimalJsonValue;
  triggerDirection?: OrderTriggerDirectionJsonValue;
  triggerPriceType?: OrderTriggerPriceTypeJsonValue;
  triggerTimestamp?: PrexTimestampJsonValue;
  orderTpTriggerPrice?: PrexDecimalJsonValue;
  orderTpTriggerPriceType?: OrderTriggerPriceTypeJsonValue;
  orderSlTriggerPrice?: PrexDecimalJsonValue;
  orderSlTriggerPriceType?: OrderTriggerPriceTypeJsonValue;
  orderTpTriggerPriceRatio?: PrexDecimalJsonValue;
  orderSlTriggerPriceRatio?: PrexDecimalJsonValue;
  orderTpOrderQty?: PrexDecimalJsonValue;
  orderSlOrderQty?: PrexDecimalJsonValue;
  orderTpOrderType?: TpslOrderTypeJsonValue;
  orderTpLimitPrice?: PrexDecimalJsonValue;
  orderTpPriceMatchStrategy?: PriceMatchStrategyJsonValue;
  orderSlOrderType?: TpslOrderTypeJsonValue;
  orderSlLimitPrice?: PrexDecimalJsonValue;
  orderSlPriceMatchStrategy?: PriceMatchStrategyJsonValue;
  waitingTrigger?: boolean;
  isReduceOnly?: boolean;
}
export function PswapOrderDelta_fromJsonValue(json: PswapOrderDeltaJsonValue): PswapOrderDelta {
  return {
    accountId: json['accountId'] != null ? json['accountId'] : undefined,
    slot: json['slot'] != null ? json['slot'] : undefined,
    symbol: json['symbol'] != null ? Symbol_fromJsonValue(json['symbol']) : undefined,
    initLeverage: json['initLeverage'] != null ? json['initLeverage'] : undefined,
    side: json['side'] != null ? PswapOrderSide_fromJsonValue(json['side']) : undefined,
    price: json['price'] != null ? PrexDecimal_fromJsonValue(json['price']) : undefined,
    priceMatchStrategy: json['priceMatchStrategy'] != null ? PriceMatchStrategy_fromJsonValue(json['priceMatchStrategy']) : undefined,
    qty: json['qty'] != null ? PrexDecimal_fromJsonValue(json['qty']) : undefined,
    amount: json['amount'] != null ? PrexDecimal_fromJsonValue(json['amount']) : undefined,
    leavesAmount: json['leavesAmount'] != null ? PrexDecimal_fromJsonValue(json['leavesAmount']) : undefined,
    conditionalOrderType: json['conditionalOrderType'] != null ? ConditionalOrderType_fromJsonValue(json['conditionalOrderType']) : undefined,
    triggerPrice: json['triggerPrice'] != null ? PrexDecimal_fromJsonValue(json['triggerPrice']) : undefined,
    triggerDirection: json['triggerDirection'] != null ? OrderTriggerDirection_fromJsonValue(json['triggerDirection']) : undefined,
    triggerPriceType: json['triggerPriceType'] != null ? OrderTriggerPriceType_fromJsonValue(json['triggerPriceType']) : undefined,
    triggerTimestamp: json['triggerTimestamp'] != null ? PrexTimestamp_fromJsonValue(json['triggerTimestamp']) : undefined,
    orderTpTriggerPrice: json['orderTpTriggerPrice'] != null ? PrexDecimal_fromJsonValue(json['orderTpTriggerPrice']) : undefined,
    orderTpTriggerPriceType: json['orderTpTriggerPriceType'] != null ? OrderTriggerPriceType_fromJsonValue(json['orderTpTriggerPriceType']) : undefined,
    orderSlTriggerPrice: json['orderSlTriggerPrice'] != null ? PrexDecimal_fromJsonValue(json['orderSlTriggerPrice']) : undefined,
    orderSlTriggerPriceType: json['orderSlTriggerPriceType'] != null ? OrderTriggerPriceType_fromJsonValue(json['orderSlTriggerPriceType']) : undefined,
    orderTpTriggerPriceRatio: json['orderTpTriggerPriceRatio'] != null ? PrexDecimal_fromJsonValue(json['orderTpTriggerPriceRatio']) : undefined,
    orderSlTriggerPriceRatio: json['orderSlTriggerPriceRatio'] != null ? PrexDecimal_fromJsonValue(json['orderSlTriggerPriceRatio']) : undefined,
    orderTpOrderQty: json['orderTpOrderQty'] != null ? PrexDecimal_fromJsonValue(json['orderTpOrderQty']) : undefined,
    orderSlOrderQty: json['orderSlOrderQty'] != null ? PrexDecimal_fromJsonValue(json['orderSlOrderQty']) : undefined,
    orderTpOrderType: json['orderTpOrderType'] != null ? TpslOrderType_fromJsonValue(json['orderTpOrderType']) : undefined,
    orderTpLimitPrice: json['orderTpLimitPrice'] != null ? PrexDecimal_fromJsonValue(json['orderTpLimitPrice']) : undefined,
    orderTpPriceMatchStrategy: json['orderTpPriceMatchStrategy'] != null ? PriceMatchStrategy_fromJsonValue(json['orderTpPriceMatchStrategy']) : undefined,
    orderSlOrderType: json['orderSlOrderType'] != null ? TpslOrderType_fromJsonValue(json['orderSlOrderType']) : undefined,
    orderSlLimitPrice: json['orderSlLimitPrice'] != null ? PrexDecimal_fromJsonValue(json['orderSlLimitPrice']) : undefined,
    orderSlPriceMatchStrategy: json['orderSlPriceMatchStrategy'] != null ? PriceMatchStrategy_fromJsonValue(json['orderSlPriceMatchStrategy']) : undefined,
    waitingTrigger: json['waitingTrigger'] != null ? json['waitingTrigger'] : undefined,
    isReduceOnly: json['isReduceOnly'] != null ? json['isReduceOnly'] : undefined,
  };
}
export function PswapOrderDelta_toJsonValue(value: PswapOrderDelta): PswapOrderDeltaJsonValue {
  return {
    'accountId': value.accountId != null ? value.accountId : undefined,
    'slot': value.slot != null ? value.slot : undefined,
    'symbol': value.symbol != null ? Symbol_toJsonValue(value.symbol) : undefined,
    'initLeverage': value.initLeverage != null ? value.initLeverage : undefined,
    'side': value.side != null ? PswapOrderSide_toJsonValue(value.side) : undefined,
    'price': value.price != null ? PrexDecimal_toJsonValue(value.price) : undefined,
    'priceMatchStrategy': value.priceMatchStrategy != null ? PriceMatchStrategy_toJsonValue(value.priceMatchStrategy) : undefined,
    'qty': value.qty != null ? PrexDecimal_toJsonValue(value.qty) : undefined,
    'amount': value.amount != null ? PrexDecimal_toJsonValue(value.amount) : undefined,
    'leavesAmount': value.leavesAmount != null ? PrexDecimal_toJsonValue(value.leavesAmount) : undefined,
    'conditionalOrderType': value.conditionalOrderType != null ? ConditionalOrderType_toJsonValue(value.conditionalOrderType) : undefined,
    'triggerPrice': value.triggerPrice != null ? PrexDecimal_toJsonValue(value.triggerPrice) : undefined,
    'triggerDirection': value.triggerDirection != null ? OrderTriggerDirection_toJsonValue(value.triggerDirection) : undefined,
    'triggerPriceType': value.triggerPriceType != null ? OrderTriggerPriceType_toJsonValue(value.triggerPriceType) : undefined,
    'triggerTimestamp': value.triggerTimestamp != null ? PrexTimestamp_toJsonValue(value.triggerTimestamp) : undefined,
    'orderTpTriggerPrice': value.orderTpTriggerPrice != null ? PrexDecimal_toJsonValue(value.orderTpTriggerPrice) : undefined,
    'orderTpTriggerPriceType': value.orderTpTriggerPriceType != null ? OrderTriggerPriceType_toJsonValue(value.orderTpTriggerPriceType) : undefined,
    'orderSlTriggerPrice': value.orderSlTriggerPrice != null ? PrexDecimal_toJsonValue(value.orderSlTriggerPrice) : undefined,
    'orderSlTriggerPriceType': value.orderSlTriggerPriceType != null ? OrderTriggerPriceType_toJsonValue(value.orderSlTriggerPriceType) : undefined,
    'orderTpTriggerPriceRatio': value.orderTpTriggerPriceRatio != null ? PrexDecimal_toJsonValue(value.orderTpTriggerPriceRatio) : undefined,
    'orderSlTriggerPriceRatio': value.orderSlTriggerPriceRatio != null ? PrexDecimal_toJsonValue(value.orderSlTriggerPriceRatio) : undefined,
    'orderTpOrderQty': value.orderTpOrderQty != null ? PrexDecimal_toJsonValue(value.orderTpOrderQty) : undefined,
    'orderSlOrderQty': value.orderSlOrderQty != null ? PrexDecimal_toJsonValue(value.orderSlOrderQty) : undefined,
    'orderTpOrderType': value.orderTpOrderType != null ? TpslOrderType_toJsonValue(value.orderTpOrderType) : undefined,
    'orderTpLimitPrice': value.orderTpLimitPrice != null ? PrexDecimal_toJsonValue(value.orderTpLimitPrice) : undefined,
    'orderTpPriceMatchStrategy': value.orderTpPriceMatchStrategy != null ? PriceMatchStrategy_toJsonValue(value.orderTpPriceMatchStrategy) : undefined,
    'orderSlOrderType': value.orderSlOrderType != null ? TpslOrderType_toJsonValue(value.orderSlOrderType) : undefined,
    'orderSlLimitPrice': value.orderSlLimitPrice != null ? PrexDecimal_toJsonValue(value.orderSlLimitPrice) : undefined,
    'orderSlPriceMatchStrategy': value.orderSlPriceMatchStrategy != null ? PriceMatchStrategy_toJsonValue(value.orderSlPriceMatchStrategy) : undefined,
    'waitingTrigger': value.waitingTrigger != null ? value.waitingTrigger : undefined,
    'isReduceOnly': value.isReduceOnly != null ? value.isReduceOnly : undefined,
  };
}

export interface PswapOrderTableUpdates {
  s?: Record<Uuid, PswapOrder>;
  u?: Record<Uuid, PswapOrderDelta>;
  i?: Record<Uuid, PswapOrder>;
  d?: Record<Uuid, unknown>;
}
export interface PswapOrderTableUpdatesJsonValue {
  s?: Record<Uuid, PswapOrderJsonValue>;
  u?: Record<Uuid, PswapOrderDeltaJsonValue>;
  i?: Record<Uuid, PswapOrderJsonValue>;
  d?: Record<Uuid, unknown>;
}
export function PswapOrderTableUpdates_fromJsonValue(json: PswapOrderTableUpdatesJsonValue): PswapOrderTableUpdates {
  return {
    s: json['s'] != null ? Object.fromEntries(Object.entries(json['s']).map(([k, v]) => [k, PswapOrder_fromJsonValue(v)])) : undefined,
    u: json['u'] != null ? Object.fromEntries(Object.entries(json['u']).map(([k, v]) => [k, PswapOrderDelta_fromJsonValue(v)])) : undefined,
    i: json['i'] != null ? Object.fromEntries(Object.entries(json['i']).map(([k, v]) => [k, PswapOrder_fromJsonValue(v)])) : undefined,
    d: json['d'] != null ? json['d'] : undefined,
  };
}
export function PswapOrderTableUpdates_toJsonValue(value: PswapOrderTableUpdates): PswapOrderTableUpdatesJsonValue {
  return {
    's': value.s != null ? Object.fromEntries(Object.entries(value.s).map(([k, v]) => [k, PswapOrder_toJsonValue(v)])) : undefined,
    'u': value.u != null ? Object.fromEntries(Object.entries(value.u).map(([k, v]) => [k, PswapOrderDelta_toJsonValue(v)])) : undefined,
    'i': value.i != null ? Object.fromEntries(Object.entries(value.i).map(([k, v]) => [k, PswapOrder_toJsonValue(v)])) : undefined,
    'd': value.d != null ? value.d : undefined,
  };
}

export interface AccountPswapOrderTableUpdates {
  s?: Record<AccountOrderKey, PswapOrder>;
  u?: Record<AccountOrderKey, PswapOrderDelta>;
  i?: Record<AccountOrderKey, PswapOrder>;
  d?: Record<AccountOrderKey, unknown>;
}
export interface AccountPswapOrderTableUpdatesJsonValue {
  s?: Record<AccountOrderKey, PswapOrderJsonValue>;
  u?: Record<AccountOrderKey, PswapOrderDeltaJsonValue>;
  i?: Record<AccountOrderKey, PswapOrderJsonValue>;
  d?: Record<AccountOrderKey, unknown>;
}
export function AccountPswapOrderTableUpdates_fromJsonValue(json: AccountPswapOrderTableUpdatesJsonValue): AccountPswapOrderTableUpdates {
  return {
    s: json['s'] != null ? Object.fromEntries(Object.entries(json['s']).map(([k, v]) => [k, PswapOrder_fromJsonValue(v)])) : undefined,
    u: json['u'] != null ? Object.fromEntries(Object.entries(json['u']).map(([k, v]) => [k, PswapOrderDelta_fromJsonValue(v)])) : undefined,
    i: json['i'] != null ? Object.fromEntries(Object.entries(json['i']).map(([k, v]) => [k, PswapOrder_fromJsonValue(v)])) : undefined,
    d: json['d'] != null ? json['d'] : undefined,
  };
}
export function AccountPswapOrderTableUpdates_toJsonValue(value: AccountPswapOrderTableUpdates): AccountPswapOrderTableUpdatesJsonValue {
  return {
    's': value.s != null ? Object.fromEntries(Object.entries(value.s).map(([k, v]) => [k, PswapOrder_toJsonValue(v)])) : undefined,
    'u': value.u != null ? Object.fromEntries(Object.entries(value.u).map(([k, v]) => [k, PswapOrderDelta_toJsonValue(v)])) : undefined,
    'i': value.i != null ? Object.fromEntries(Object.entries(value.i).map(([k, v]) => [k, PswapOrder_toJsonValue(v)])) : undefined,
    'd': value.d != null ? value.d : undefined,
  };
}
